import { render, staticRenderFns } from "./LTileLayer_v2.vue?vue&type=template&id=1272b662&"
import script from "./LTileLayer_v2.vue?vue&type=script&lang=js&"
export * from "./LTileLayer_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports